import baseApi from "./baseApi";
import moment from "moment";

export default {
    async getTemplatedProfiles(templateProfileID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/forecasting/templatedProfiles?berriesForecastProfileID=${templateProfileID}`);
        return result.data;
    },
    async getPlantProfileTemplates(plantID){
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/forecasting/PlantProfileTemplateData?plantID=${plantID}`);
        return result.data;
    },
    async postUpdateForecastProfile(unsentForecastProfile){
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/forecasting/updateForecastProfileData", unsentForecastProfile);

        return result.data;
    },
    async postToggleArchiveForecastProfile(profileID){
        let request = await baseApi.createHttpRequest();
        await request.post(`/forecasting/toggleArchiveForecastProfileData/${profileID}`);
    },
    async getCropForecastProfiles(cropLocationID){
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/forecasting/cropForecastProfileData?" + [
            "CropLocationID=" + cropLocationID
        ].join("&"));
        return result.data;
    },
    async getPlantProfileTemplatesForCrop(cropLocationID){
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/forecasting/plantProfileTemplatesForCropData?" + [
            "CropLocationID=" + cropLocationID
        ].join("&"));
        return result.data;
    },
    async getCropForecasts(cropLocationID, varietyID, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/forecasting/cropForecastData?${[
            `cropLocationID=${cropLocationID}`,
            `varietyID=${varietyID}`,
            `startDate=${moment(startDate).format('YYYY-MM-DD')}`,
            `endDate=${moment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);

        return result.data;
    },
    async downloadPlantProfileTemplateData(profileTemplatesIDs){
        let request = await baseApi.createHttpRequest("blob");
        let result = await request.post(`/forecasting/downloadPlantProfileTemplateData`, profileTemplatesIDs);
        
        return result.data;
    },
    async uploadProfileTemplates(payload) {
        let request = await baseApi.createHttpRequest();
        let data = new FormData();
        data.set(payload.file.name, payload.file.data);
        
        let result = await request.post("/forecasting/uploadProfileTemplates?commit=" + payload.commit, data, {
            headers: {
                "Content-Type": "multipart/form-data; boundary=" + data._boundary
            }
        });
        return result.data;
    }
}